import * as React from "react";
import { connect } from "react-redux";
import Typography from "@material-ui/core/Typography";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";
import { RouteComponentProps } from "react-router";
import routes from "../../constants/routes";
import { authActions } from "../../reducers/authentication";

const styles = (theme: Theme) =>
  createStyles({
    container: {
      alignItems: "center",
      display: "flex",
      height: "calc(100vh - 80px)",
      justifyContent: "center",
      width: "100%"
    }
  });

type State = {};

type Props = RouteComponentProps & {
  classes?: any;
  setToken: (token: string) => void;
};

class OauthHandler extends React.Component<Props, State> {
  componentWillMount() {
    const param = this.props.location.search;
    const token = param.replace("?token=", "");
    this.props.setToken(token);
    this.props.history.push(routes.HOME.url);
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <Typography variant="h1">Authenticating</Typography>
      </div>
    );
  }
}

export const styled = withStyles(styles)(OauthHandler);
const mapDispatchToProps = {
  setToken: authActions.setToken
};
export default connect(
  null,
  mapDispatchToProps
)(styled);
